export default __webpack_public_path__ + "static/newlogo-55e13c39fbe1d805f31b92c0f1642bdc.png";